import React from 'react';
import { useParams } from 'react-router';
import styled from 'styled-components';
import Prescription from './containers/Prescription';
import OrderInfo from './containers/OrderInfo';
import useOrderQuery from '@/hooks/order/useOrderQuery';
import { parseOrderDetail } from '@/services/order';
import { DomainName } from '@/api/bff_types';
import { WARNING_NOTICE_HEIGHT } from './containers/WarningNotice';

const OrderDetailPage = () => {
  const params = useParams<{ id: string }>();
  const orderId = params.id;
  const { orderDetailQuery, getCommerceOrderQuery } = useOrderQuery();
  const { data } = orderDetailQuery(orderId);
  const { data: additionalOrderInfo } = getCommerceOrderQuery({
    domain: DomainName.PHARMACY,
    key: String(data?.id || '')
  });

  if (!data) {
    return null;
  }

  const order = parseOrderDetail(data!);

  return (
    <Wrapper>
      <Prescription order={order} />
      <OrderInfo order={order} additionalOrderInfo={additionalOrderInfo} />
    </Wrapper>
  );
};

export default OrderDetailPage;

const Wrapper = styled.div`
  width: 100%;
  gap: 20px;
  flex-flow: row;
  display: flex;
  margin-top: ${WARNING_NOTICE_HEIGHT}px;
`;
